<template>
    <div class="chat-group" :class="accordionClasses" v-if="teachersBlock">
        <strong @click="toggleAccordion">
            <span v-if="allPrefix">{{$t('all')}} </span>
            {{ $t('teachers') }}
            <span class="aside-menu__arrow-box"></span> 
        </strong>
        <vue-custom-scrollbar class="accordion scroll-area">
            <div class="chat-group__list">
                <template v-if="teachersArray && teachersArray.length > 0">
                    <app-right-panel-member
                            v-for="member in teachersArray"
                            :member="member"
                            :key="member.id"
                    ></app-right-panel-member>
                </template>
                <template v-else>
                    <p class="chat-group_not-found">{{ $t('search_members_not_found') }}</p>
                </template>
            </div>

        </vue-custom-scrollbar>
    </div>

</template>

<script>
    import {mapGetters} from 'vuex';
    import RightPanelMember from './RightPanelMember.vue';
    import vueCustomScrollbar from 'vue-custom-scrollbar'

    export default {
        data: () => ({
            isOpen: true,
            settings: {
                maxScrollbarLength: 60,
                swipeEasing: true
            },
        }), 
        components: {
            appRightPanelMember: RightPanelMember,
            vueCustomScrollbar: vueCustomScrollbar,
        },
        methods: {
            toggleAccordion() {
                this.isOpen = !this.isOpen;
            }
        },
        computed: {
            ...mapGetters([
                'channelTeachers',
                'allPrefix',
                'teachers',
                'searchMembers'
            ]),
            teachersBlock() {
                return this.teachers.length || this.channelTeachers !== 'undefined' && this.channelTeachers !== null &&
                    this.channelTeachers.length !== 0 || this.searchMembers && this.searchMembers.students.length > 0
            },
            teachersArray() {
                let teachersList = [];
                if (this.searchMembers && this.searchMembers.teachers.length > 0) {
                    for (let item of this.searchMembers.teachers) {
                        teachersList.push(Object.assign({}, item, {role: 'teacher'}))
                    }
                }
                if (this.channelTeachers !== undefined && this.channelTeachers !== null) {
                    return this.searchMembers && this.searchMembers.teachers.length > 0 ? teachersList
                        : (this.searchMembers === null || this.searchMembers === undefined) ? this.channelTeachers : []
                }
            },
            accordionClasses: function() {
                return {
                    'is-closed': !this.isOpen,
                    'is-primary': this.isOpen
                };
            }
        },
    }
</script>

<style scoped>
    .scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: 100%;
    }

    .accordion {
        max-height: 100%;
        transition: 0.3s ease all;
    } 

    .is-closed .accordion {
        max-height: 0;
    }
</style>